import React, { createContext, useContext, useState } from 'react';

// Språk-nycklar: ALLA UI-texter och saknade nycklar läggs till här!
export const translations = {
  sv: {
    // Header & navigation
    importGeoJSON: "Ladda upp GeoJSON",
    exportGeoJSON: "Spara GeoJSON",
    selectAirport: "Välj flygplats",
    information: "Information",
    help: "Hjälp",
    aboutUs: "Om oss",
    language: "Svenska",
    close: "Stäng",
    // Tooltip
    tooltip_measure: "Klicka i kartan för att mäta avstånd",
    tooltip_openCoordInput: "Öppna koordinat inmatning",
    tooltip_draw: "Rita objekt på kartan",
    tooltip_delete: "Ta bort objekt",
    tooltip_zoom: "Zooma in/ut på kartan",
    tooltip_help: "Visa hjälpinformation",
    tooltip_info: "Visa mer information",
    // Leaflet draw tooltips
    tooltip_edit: "Redigera lager",
    tooltip_editDisabled: "Inga lager att redigera",
    tooltip_deleteDisabled: "Inga lager att ta bort",
    tooltip_drawPolylineStart: "Klicka för att börja rita linje",
    tooltip_drawPolylineCont: "Klicka för att fortsätta rita linje",
    tooltip_drawPolylineEnd: "Klicka på sista punkten för att avsluta linjen",
    tooltip_drawPolygonStart: "Klicka för att börja rita form",
    tooltip_drawPolygonCont: "Klicka för att fortsätta rita form",
    tooltip_drawPolygonEnd: "Klicka på första punkten för att stänga formen",
    tooltip_drawMarker: "Klicka på kartan för att placera markör",
    tooltip_drawCircleStart: "Klicka och dra för att rita cirkel",
    tooltip_drawCircleRadius: "Radie",
    tooltip_zoomIn: "Zooma in",
    tooltip_zoomOut: "Zooma ut",
    // LayerPanel
    backgroundLayers: "Bakgrundslager",
    userdataLayers: "Användarens egen datalager",
    informationLayers: "Informationslager",
    protectionAreas: "Flygplatsens skyddsområden",
    openStreetMap: "OpenStreetMap",
    cartoDBLight: "CartoDB Light",
    esriAerial: "Flygbilder ESRI",
    openRailwayMap: "OpenRailwayMap",
    swedishAirports: "Svenska flygplatser",
    enrNavaids: "ENR NAVAIDS",
    nav: "NAV",
    tmaTia: "TMA/TIA",
    ctrTizRmz: "CTR/TIZ/RMZ",
    icaoDoc015: "ICAO Doc 015",
    annex14: "ICAO Annex 14",
    etod: "ICAO Annex 15-eTOD",
    easa: "EASA MVA",
    pansOps: "ICAO Doc 8168-PANS OPS",
    reloadLayers: "Ladda om lager",
    loadingLayers: "Laddar lager...",
    analyzingData: "Analyserar data...",
    generatingPdfReport: "Skapar PDF rapporten...",
    toggleLayer: "Växla lager",
    turnOnLayer: "Tänd",
    turnOffLayer: "Släck",
    zoomToAirport: "Zooma till flygplats",
    noAirportSelected: "Ingen flygplats vald",
    loadingAirports: "Laddar flygplatser...",
    error: "Fel",
    // CoordinateInputTool
    coordinateInput_title: "Koordinatinmatning",
    coordinateInput_point: "Punkt",
    coordinateInput_line: "Linje",
    coordinateInput_polygon: "Polygon",
    coordinateInput_circle: "Cirkel",
    coordinateInput_coordFormat: "Koordinatformat:",
    coordinateInput_name: "Namn:",
    coordinateInput_clear: "Rensa formulär",
    coordinateInput_zoom: "Zooma till nytt objekt",
    coordinateInput_addToMap: "Lägg till i karta",
    coordinateInput_radius: "Radie:",
    coordinateInput_unit_nm: "NM",
    coordinateInput_unit_meter: "meter",
    coordinateInput_error: "Du måste ange lat, lon, z på varje rad. Alla värden måste vara korrekta.",
    coordinateInput_placeholder_point: "Skriv in: lat, lon, z\nEx: 58.233333, 17.116667, 120",
    coordinateInput_placeholder_line: "Skriv in varje punkt på en rad:\n58.233333, 17.116667, 120\n58.233333, 17.516667, 130",
    coordinateInput_placeholder_polygon: "Skriv in varje hörn på en rad (första och sista punkt kopplas ihop):\n58.233333, 17.116667, 120\n58.233333, 17.516667, 120\n57.833333, 17.233333, 120\n58.233333, 17.116667, 120",
    coordinateInput_placeholder_circle: "Skriv in mittpunkt på en rad: lat, lon, z\nEx: 58.233333, 17.116667, 120\nAnge radie i fältet nedan.",
    // Coordinate format help
    coordinateInput_formatHelp: "Koordinatformat hjälp:",
    coordinateInput_formatHelp_dd: "DD.dddddd (Decimalgrader): 58.233333, 17.116667",
    coordinateInput_formatHelp_dm: "DDMM.MMMM (Grader, decimalminuter): 5814.0000, 1707.0000",
    coordinateInput_formatHelp_dms: "DMS: 594559.23N, 162425.42E eller 59°45'59.23\"N, 16°24'25.42\"E. Lägg höjden sist, t.ex. , 100.",
    coordinateInput_rowHint: "En punkt per rad: latitud, longitud, höjd z (m AMSL).",
    // Mode toggle
    coordinateInput_modeManual: "Manuell",
    coordinateInput_modeImport: "Importera",
    coordinateInput_uploadFile: "Ladda upp fil…",
    coordinateInput_importTitle: "Importera objekt",
    // BulkImportTool
    bulkImport_delimiter: "Avgränsare:",
    bulkImport_delim_semicolon: "Semikolon (;)",
    bulkImport_delim_comma: "Komma (,)",
    bulkImport_delim_space: "Mellanslag",
    bulkImport_delim_tab: "Tabb",
    bulkImport_delim_custom: "Anpassad",
    bulkImport_customDelimPlaceholder: "t.ex. |",
    bulkImport_coordFormat: "Koordinatformat:",
    bulkImport_hasHeader: "Första raden är rubrik",
    bulkImport_pasteData: "Klistra in data:",
    bulkImport_uploadFile: "Välj fil",
    bulkImport_dropzoneHint: "Klicka för att välja en fil (.csv, .txt, .tsv) – eller klistra in data nedan",
    bulkImport_chooseFile: "Välj fil…",
    bulkImport_orPaste: "Eller klistra in data direkt:",
    bulkImport_pastePlaceholder: "Klistra in CSV/TSV-data här…\nEx: 58.233333,17.116667,120,MastA",
    bulkImport_columnMapping: "Kolumnmappning",
    bulkImport_col_lat: "Latitud",
    bulkImport_col_lon: "Longitud",
    bulkImport_col_alt: "Höjd (z)",
    bulkImport_col_name: "Namn",
    bulkImport_col_radius: "Radie",
    bulkImport_role_ignore: "Ignorera",
    bulkImport_colNone: "— ingen —",
    bulkImport_radiusUnit: "Radieenhet:",
    bulkImport_preview: "Förhandsgranskning –",
    bulkImport_validOf: "{valid} giltiga av {total}",
    bulkImport_valid: "OK",
    bulkImport_import: "Importera {count} objekt",
    bulkImport_showingFirst100: "Visar de första 100 raderna.",
    bulkImport_noValidRows: "Inga giltiga rader att importera.",
    bulkImport_nameRequired: "⚠ Välj en kolumn för Namn – krävs för import.",
    // HelpPopup
    help_title: "Verktygshjälp",
    help_measure: "Klicka för att mäta avstånd och områden på kartan. Dubbelklicka för att avsluta mätningen.",
    help_zoom: "Använd mushjulet eller +/- knapparna för att zooma in och ut på kartan.",
    help_layers: "Växla mellan olika bakgrundslager och visa/dölj informationslager.",
    // InformationPopup
    info_tips_title: "Användartips",
    info_tips_1: "Denna applikation hjälper dig att analysera obstacle limitation surfaces (OLS) för flygplatser.",
    info_tips_2: "Använd lagerpanelen för att visa olika bakgrundslager och informationslager.",
    info_tips_3: "Välj en flygplats från rullgardinsmenyn för att zooma till dess position.",
    info_tips_4: "Ladda upp GeoJSON-filer för att analysera objekt mot flygplatsens skyddszoner.",
    info_tips_5: "Klicka på objekt i kartan för att få mer information.",
    info_tips_6: "Klicka på hjälpikonen för att få information om verktyg och funktioner.",
    // GeoJsonIO
    geoJson_uploadFailed: "Kunde inte tolka GeoJSON!",
    // CoordinateInfoBox
    coordinateInfo_format: "Koordinatformat:",
    coordinateInfo_lat: "Lat:",
    coordinateInfo_lng: "Lng:",
    coordinateInfo_z: "z (lägsta yta AMSL):",
    coordinateInfo_zAccessMessage: "Logga in med en aktiv prenumeration för att se Z-värdet i realtid.",
    // ANALYS & PDF/Tabeller
    exportPdfTitle: "FlightSafe Analyzer Resultat av Flyghinderanalys",
    analyze: "Analysera",
    exportPdf: "Exportera PDF-rapport",
    result: "Resultat",
    penetration: "Penetration av yta",
    noPenetration: "Inga penetrationer",
    object: "Objekt",
    airport: "Flygplats",
    surface: "Yta",
    runway: "Bana",
    regulation: "Regelverk",
   // objectHeightM: "Objekthöjd (m)",
	objectHeightM: "Z (m) AMSL",
   // surfaceHeightM: "Ythöjd (m)",
	surfaceHeightM: "Ytan (m) AMSL",
    penetratesQ: "Påverkan?",
    yes: "Ja",
    no: "Nej",
    numPoints: "Antal punkter",
    penetrationMAll: "Penetration",
    horizontalTolerance: "Horisontell tolerans (m)",
    greenHint: "Grön rad = ingen penetration",
    redHint: "Röd rad = penetration",
    tips: "Tips",
    toggleLayersTip: "Använd panelen till höger för att visa/dölja lager.",
    switchBasemapTip: "Byt bakgrundskarta med lagerpanelen.",
    drawDeleteTip: "Rita eller radera objekt med ritverktyget.",
    coordHeightPanelTip: "Håll musen över objekt för att se koordinater och höjd.",
    circleZRadiusTip: "Cirklar ritas med mittpunkt, höjd och radie.",
    importExportTip: "Importera eller exportera GeoJSON-filer för att spara/ladda objekt.",
    tipAlwaysChooseSaveLocation: "Välj alltid var filen ska sparas.",
    browserDownloadHint: " (webbläsaren kan fråga om plats vid nedladdning).",
    importReplacePrompt: "Vill du ersätta befintliga objekt eller lägga till?",
    replace: "Ersätt",
    add: "Lägg till",
    cancel: "Avbryt",
    loading: "Laddar...",
    geometry: "Geometri",
    // PropertyModal
    objectProperties: "Objektegenskaper",
    pointProperties: "Punktens egenskaper",
    lineProperties: "Linjens egenskaper", 
    circleProperties: "Cirkelns egenskaper",
    name: "Namn",
    height: "Z (m) AMSL",
    lineHeightDescription: "Z-värde för varje punkt (kommaseparerat) eller ett enda värde för hela linjen",
    lineHeightPlaceholder: "Ex: 15,16,17 eller 15",
    radius: "Radie (meter)",
    save: "Spara",
    // PDF Export
    pdfTitle: "FlightSafe Analyzer – Flyghinderanalys",
    background: "Bakgrund",
    backgroundText1: "{contact_person} ({email}){company} har utfört en flyghinderanalys med hjälp av FlightSafe Analyzer den {date}.",
    backgroundText1Fallback: "Ni har utfört en flyghinderanalys med hjälp av FlightSafe Analyzer den {date}.",
    backgroundText2: "Analysen omfattar påverkan på flygtrafik och teknisk utrustning i området.",
    affectedAirports: "Berörda flygplatser",
    noAffectedAirports: "(Inga berörda flygplatser/sjukhus identifierade)",
    resultSummary: "Sammanfattning av resultat",
    resultSummaryText: "Nedan presenteras en översiktlig sammanställning av analysens resultat, där varje objekt och dess påverkan på olika flygsäkerhetsområden redovisas.",
    analysisTitle: "Analys",
    analysisIntro: "Flyghinderanalysen består av fem delar:",
    analysisPart1: "1. Förteckning över planerat/planerade byggnadsverk",
    analysisPart2: "2. Påverkan på flygplatsers hinderbegränsande ytor",
    analysisPart3: "3. Påverkan på flygplatsers luftrum",
    analysisPart4: "4. Påverkan på flygplatsers flygprocedurer",
    analysisPart5: "5. Påverkan på flygplatsers tekniska utrustningen",
    buildingsList: "1. Förteckning över planerat/planerade byggnadsverk",
    objectType: "Objekttyp",
    coordinates: "Koordinater (DMS)",
    mapTitle: "Karta över planerat/planerade byggnadsverk",
    impactOnSurfaces: "2. Påverkan på flygplatsers hinderbegränsande ytor",
    penetratesEasa: "Penetrerar yta (EASA MVA)",
    noPenetrationEasa: "Inga penetrationer men inom yta (EASA MVA)",
    impactOnAirspace: "3. Påverkan på flygplatsers luftrum",
    airspaceType: "Typ",
    lowerLimit: "Lower",
    upperLimit: "Upper",
    airportCode: "Flygplatskod",
    objectName: "Objektnamn",
    airspace: "Airspace",
    airspaceWarning: "{count} ritade objekt hamnar inom följande luftrum: {airspaces}.",
    airspaceWarningText: "Vindkraftsparker och objekt med en höjd över 100 meter över marknivå (AGL) bör undvikas inom dessa luftrum, då de kan utgöra en betydande risk för flygsäkerheten.",
    noAirspaceText: "Inga ritade objekt hamnar inom identifierade luftrum (CTR/TIZ/RMZ) i databasen.",
    impactOnProcedures: "4. Påverkan på flygplatsers flygprocedurer",
    penetratesPansOps: "Penetrerar yta (ICAO Doc 8168-PANS OPS)",
    noPenetrationPansOps: "Inga penetrationer men inom yta (ICAO Doc 8168-PANS OPS)",
    impactOnTechnicalEquipment: "5. Påverkan på flygplatsers tekniska utrustningen",
    impactOnSurfacesAnnex14: "Påverkan på flygplatsers hinderbegränsande ytor (ICAO ANNEX 14)",
    impactOnSurfacesEasa: "Påverkan på ATS vektoreringshöjder",
    impactOnSurfacesEtod: "Påverkan på Area 1-4 (eTOD)",
    penetratesAnnex14: "Penetrerar yta (ICAO ANNEX 14)",
    noPenetrationAnnex14: "Inga penetrationer men inom yta (ICAO ANNEX 14)",
    penetratesEtod: "Penetrerar yta (ICAO Annex 15-eTOD)",
    noPenetrationEtod: "Inga penetrationer men inom yta (ICAO Annex 15-eTOD)",
    noImpact: "Ingen påverkan identifierad.",
    shieldingPenetrationNote: "Objektet genomtränger ytor för flygplatsens tekniska utrustning i enlighet med ICAO EUR Doc 015. Även om ytan inte är höjdbegränsande anger vägledningen att hinder som genomtränger ytorna kräver en mer detaljerad analys för att fastställa eventuell påverkan på CNS-signaler.",
    importantInformation: "Viktig information",
    importantInfoText: "Enligt luftfartslagen måste en flyghinderanmälan skickas till Försvarsmakten minst fyra veckor innan objektet når 20 m höjd eller 45 m inom tätbebyggt område.\nHindren ska markeras enligt Transportstyrelsens föreskrifter (TSFS 2020:88 och TSFS 2019:22).",
    recommendation: "Rekommendation",
    recommendationText: "Kontakta berörda flygplatser direkt för deras bedömning, eftersom de är sakägare i ärendet.",
    airportAddresses: "Adressuppgifter berörda flygplatser",
    operator: "Operatör",
    address: "Adress",
    phone: "Telefon",
    fax: "Fax",
    email: "E-post",
    website: "Webb",
    noAddressRegistered: "(Ingen adress registrerad)",
    pageOf: "Sida {current} av {total}",
    footerText: "FlightSafe Analyzer • www.flightsafe.se",
    date: "Datum",
    // Table headers
    object: "Objekt",
    analysis: "Analys",
    withinSurfaceYes: "Inom ytan Ja",
    withinSurfaceNo: "Inom ytan Nej",
    comment: "Kommentar",
    withoutNotification: "Utan anm.",
    withNotification: "Anm.",
    summaryCritical: "Kritisk",
    // ResultatTable
    analysisError: "Fel vid hämtning av analys",
    invalidAnalysisResult: "Ogiltigt analysresultat från servern",
    couldNotFetchAnalysis: "Kunde inte hämta analys",
    noAnalysisToShow: "Ingen analys att visa ännu.",
    loadingAnalysis: "Laddar analys...",
    // Analysis types for buildSummaryRows
    analysisType_surfacesAnnex14: "Hinderbegränsande ytor (ICAO ANNEX 14)",
    analysisType_surfacesEasa: "ATS vektoreringshöjder",
    analysisType_surfacesEtod: "Area 1-4 (eTOD)",
    analysisType_airspaceTmaTia: "Luftrum (TMA/TIA)",
    analysisType_airspaceAts: "Luftrum (CTR/TIZ/RMZ/ATS)",
    analysisType_proceduresPansOps: "Flygprocedurer (ICAO Doc 8168-PANS OPS)",
    analysisType_technicalIcao: "Teknisk utrustning (ICAO Doc 015)",
    // Comments for buildSummaryRows
    commentNoImpact: "Ingen påverkan.",
    commentPenetrates: "Objektet penetrerar ytan.",
    commentWithinNoImpact: "Objekt inom ytan, ingen påverkan.",
    commentOutsideTmaTia: "Objekt utanför TMA/TIA-luftrum.",
    commentOutsideAts: "Objekt utanför kontrollerat ATS-luftrum.",
    commentWithinAirspace: "Objektet inom {type}-luftrum.",
    commentWithinTmaTia: "Objektet inom TMA/TIA-luftrum.",
    commentWithinAts: "Objektet inom ATS-luftrum.",
    unit: "Enhet",
    // Language toggle
    tooltip_languageToggle: "Byt till engelska",
    // Authentication
    login: "Logga in",
    register: "Registrera",
    logout: "Logga ut",
    email: "E-postadress",
    password: "Lösenord",
    confirmPassword: "Bekräfta lösenord",
    loginTitle: "Logga in",
    registerTitle: "Registrera användare",
    loginButton: "Logga in",
    registerButton: "Registrera",
    forgotPassword: "Glömt lösenord?",
    alreadyHaveAccount: "Har du redan ett konto?",
    dontHaveAccount: "Har du inget konto?",
    clickHereToLogin: "Klicka här för att logga in",
    clickHereToRegister: "Klicka här för att registrera",
    airportAccess: "Flygplatsåtkomst",
    airportAccessHelp: "Välj vilka flygplatser du vill ha tillgång till",
    searchAirportPlaceholder: "Sök flygplats...",
    selectAll: "Välj alla",
    deselectAll: "Avmarkera alla",
    noAirportsSelected: "Inga flygplatser valda",
    oneAirportSelected: "1 flygplats vald",
    manyAirportsSelected: "{{count}} flygplatser valda",
    done: "✔ Klart!",
    chooseMinAirports: "Välj minst 1 flygplats!",
    regionStockholm: "Stockholm",
    regionSouthSweden: "Sydsverige",
    regionWestSweden: "Västsverige",
    regionNorthSweden: "Norrland",
    regionEastSweden: "Östsverige",
    regionCentralSweden: "Mellansverige",
    accessLevel_NONE: "Ingen åtkomst",
    accessLevel_ESSA: "Endast ESSA (Stockholm Arlanda)",
    accessLevel_ESSP: "Endast ESSP (Norrköping Kungsängen)",
    accessLevel_MULTI: "ESSA, ESSB, ESSP",
    accessLevel_ALL: "Alla flygplatser",
    registrationSuccess: "Registrering lyckades! Du kan nu logga in.",
    loginSuccess: "Inloggning lyckades!",
    loginFailed: "Felaktiga inloggningsuppgifter",
    registrationFailed: "Registrering misslyckades",
    passwordMismatch: "Lösenorden stämmer inte överens",
    requiredField: "Detta fält är obligatoriskt",
    // Version info
    version: "Version:",
    lastUpdated: "Senast uppdaterad:",
    // Subscription/Payment messages
    subscriptionRequired: "Prenumeration krävs",
    subscriptionMessage: "För att exportera PDF-rapporter behöver du en aktiv prenumeration. Kontakta oss för mer information. Observera att prenumerationen är helt kostnadsfri och utan förpliktelser!",
    footerSubscriptionInfo: "För att exportera PDF-rapporter behöver du en aktiv prenumeration. Observera att prenumerationen är helt kostnadsfri och utan förpliktelser!",
    contactForSubscription: "Kontakta oss för prenumeration",
    currentUser: "Inloggad som:",
    accessLevel: "Åtkomstnivå:",
    paymentStatus: "Betalningsstatus:",
    paid: "Aktiv",
    notPaid: "Ej aktiv",
    // Subscription modal translations
    haveAccountHeading: "Har du redan ett konto?",
    haveAccountDesc: "Logga in för att kontrollera din prenumerationsstatus",
    newAccountHeading: "Nytt konto?",
    newAccountDesc: "Registrera dig för att komma igång",
    contactUsHeading: "Vill du kontakta oss?",
    contactUsDesc: "Kontakta oss för information om prenumeration",
    continueWithoutRegistration: "Fortsätt utan prenumeration",
    continueDisclaimer: "Begränsad funktionalitet utan prenumeration",
    loginRequiredTitle: "Inloggning krävs",
    loginRequiredMessage: "Du måste vara inloggad för att beställa flyghinderanalys. Logga in eller registrera ett konto för att fortsätta.",
    loginRequiredLoginButton: "Logga in",
    loginRequiredRegisterButton: "Registrera",
    // Free PDF exports limit messages
    freeExportsExhausted: "Analyser utan aktiv prenumeration förbrukade",
    freeExportsExhaustedMessage: "Du har använt dina 3 analyser utan aktiv prenumeration. För att fortsätta exportera analyser behöver du en aktiv prenumeration.",
    freeExportsContactMessage: "Observera att prenumerationen är helt kostnadsfri och utan förpliktelser! Kontakta oss gärna för att aktivera prenumerationen eller om du har frågor.",
    contactInformation: "Kontaktuppgifter",
    freeExportsRemaining: "Du har {{count}} gratis PDF-export(er) kvar",
	// Tips under resultat
	tip: "Tips",
	// --- NYA KLARIFIERINGSTEXTER (placerade logiskt nära noImpact / innan importantInformation) ---
   	etodClarification: "Objektet penetrerar eTOD-ytan enligt ICAO Annex 15. Även om ytan inte är höjdbegränsande, ska hinder som penetrerar ytan publiceras i AIP av den eller de berörda flygplatserna. Permanenta hinder bör i möjligaste mån undvikas, då dessa kan begränsa flygplatsernas framtida möjligheter till planering av in- och utflygningsprocedurer.",
    techEquipmentClarification: "Objektet penetrerar ytan för teknisk utrustning. Ytan är inte höjdbegränsande, men intrång kan ändå kräva särskild utredning för att säkerställa att navigations- och övervakningsutrustning inte påverkas negativt. Större permanenta hinder, såsom byggnader eller vindkraftverk, bör undvikas inom dessa ytor.",
    // OCA dynamic text translations
    ocaBothSurfaces: "Objektet penetrerar LPV OAS och ILS OAS, men påverkar ej OCA (minima).",
    ocaLpvOnly: "Objektet penetrerar LPV OAS, men påverkar ej OCA (minima).",
    ocaIlsOnly: "Objektet penetrerar ILS OAS, men påverkar ej OCA (minima).",
    pdfReportTip: "Skapa PDF rapport med fullständiga beräkningar",
    // About Us modal content
    aboutUs_title: "Om oss",
    aboutUs_intro: "Vi gör det enkelt att ta ansvar för flygsäkerheten – på några sekunder.",
    aboutUs_description: "På Flightsafe har vi tagit fram en webbaserad självbetjäningstjänst där du snabbt och enkelt kan kontrollera om ett planerat objekt – som en mast, kran, byggnad eller annan struktur – riskerar att påverka flygplatser eller luftrum.\n\nTjänsten är framtagen för att underlätta för både individer och organisationer att fatta rätt beslut i rätt tid. Med direkt tillgång till uppdaterad flygplatsdata och luftrumsinformation får du ett snabbt och tillförlitligt svar – utan osäkerhet och utan onödig väntan.",
    aboutUs_whatWeDo_title: "Vad vi gör",
    aboutUs_whatWeDo_content: "Vi har utvecklat en digital plattform som automatiserar och förenklar Flyghinderanalyser. Tjänsten används av:\n• Byggherrar, entreprenörer och privatpersoner som vill säkerställa att deras objekt inte påverkar flygtrafiken.\n• Flygplatser som behöver få en översikt över potentiella hinder i sin närhet och bedöma hur de kan påverka flygsäkerheten eller driften.\n• Lokala ANS-leverantörer som vill skydda sina luftrum och säkerställa att navigations- och trafikledningstjänster inte störs av nya hinder.\n\nDu kan enkelt:\n• Kontrollera om ett objekt påverkar luftrum eller ligger inom skyddade områden kring flygplatser.\n• Få omedelbart svar – direkt på skärmen – baserat på uppdaterade data.\n• Ladda ner dokumentation som visar att flyghinderanalys genomförts.\n• Vid behov, få vägledning om nästa steg i processen, såsom tillstånd eller kontakt med ansvarig myndighet.",
    aboutUs_mission_title: "Vår mission",
    aboutUs_mission_content: "Vi vill göra hinderremisser och luftrumsanalys tillgängligt, begripligt och snabbt – oavsett om du bygger ett hus, ansvarar för ett flygplatssystem eller driver en ANS-tjänst. Genom att digitalisera och förenkla processen minskar vi risken för fel, förseningar och påverkan på flygsäkerheten – samtidigt som vi stärker samarbetet mellan mark- och luftrumsaktörer.",
    aboutUs_forWhom_title: "För vem?",
    aboutUs_forWhom_content: "• Byggföretag & entreprenörer som reser byggkranar, master eller andra höga objekt.\n• Privatpersoner som bygger eller installerar höga föremål nära flygplatser.\n• Konsulter & projektledare som behöver säkerställa att projekt uppfyller myndighetskrav.\n• Flygplatser som vill bevaka potentiella hinder i närheten av sina flygzoner.\n• Lokala ANS-leverantörer som vill skydda sitt luftrum från oönskad påverkan.",
    aboutUs_whyChooseUs_title: "Varför välja oss?",
    aboutUs_whyChooseUs_content: "✅ Snabbt: Direkt svar – inga handläggningstider.\n✅ Tillförlitligt: All data hålls uppdaterad enligt den globala AIRAC-cykeln och relevanta regelverk.\n✅ Enkelt: Du fyller i objektets uppgifter – vi gör kontrollen automatiskt.\n✅ Dokumenterat: Du får tydlig dokumentation för beslut, rapportering eller tillståndsansökningar.\n✅ Skalbart: Tjänsten fungerar för allt från enstaka byggprojekt till större flygplats- och ANS-aktörers behov.",
    aboutUs_future_title: "Framtiden",
    aboutUs_future_content: "Flygsäkerheten förändras – och vi ser till att du alltid har ett aktuellt beslutsunderlag.\nVår tjänst bygger på data som hålls uppdaterad i takt med AIRAC-cykeln, så att du kan lita på att varje kontroll bygger på den senaste informationen.\nMed Flightsafe är du alltid ett steg före – oavsett om du bygger på marken eller ansvarar för luftrummet.",
    aboutUs_contact_title: "Kontakta oss",
    aboutUs_contact_content: "Har du frågor eller behöver vägledning i din flyghinderanalys? Vi finns här för att hjälpa dig.\n\n📩 Du är varmt välkommen att kontakta oss på:\nkundtjanst@flightsafe.se – för allmänna frågor\nsupport@flightsafe.se – för teknisk hjälp eller ärenden kopplade till ett specifikt objekt\n\nVi svarar så snabbt vi kan – oftast redan samma dag.\nTveka inte att höra av dig – ibland räcker ett mejl för att få full klarhet.",
    // OMNI Departure Analysis
    analyzeOmni: "OMNI Analys",
    omniResults: "OMNI utflygningsresultat",
    omniDepartureResults: "OMNI utflygningsresultat",
    omniDepartures: "OMNI utflygningar",
    airport: "Flygplats",
    runway: "Bana",
    omniObjectWithin: "Objekt inom",
    omniImpact: "påverkan",
    omniNoImpact: "ingen påverkan",
    omniNoImpactCio: "ingen påverkan",
    omniCio: "CIO",
    totalObstaclesAssessed: "Totalt antal hinder bedömda",
    criticalObstacle: "Kritiskt hinder",
    calculationDetails: "Beräkningsdetaljer",
    drDistance: "Dr avstånd",
    doDistance: "Do avstånd",
    requiredMocFt: "Erforderlig MOC (ft)",
    actualAircraftAltitudeFt: "Faktisk flygplanshöjd (ft)",
    requiredCrossingAltitudeFt: "Erforderlig korsningshöjd (ft)",
    requiredPdg: "Erforderlig PDG (%)",
    criticalObstacleCol: "Kritiskt hinder",
    closeInObstacleCol: "Närliggande hinder",
    // OMNI PDF export translations
    impactOnFlightProcedures: "Påverkan på flygplatsers flygprocedurer",
    omniTableAirport: "Flygplats",
    omniTableRunway: "Bana",
    omniTableArea: "Område",
    omniTableStatus: "Status",
    omniTablePdg: "PDG-påverkan",
    cioNote: "Närliggande hinder (CIO) finns; dessa kan dock bortses från vid beräkningar.",
    omniError: "OMNI analysfel",
    omniInputParams: "Indataparametrar",
    // Shielding / Nav Aid obstacle analysis
    shieldingNavAidTitle: "Navigationsutrustning Beräkningsresultat",
    shieldingToggleHide: "Dölj NAV-ytor",
    shieldingToggleShow: "Visa NAV-ytor",
    navSurfacesRequiresAnalysis: "Kör en analys först för att visa NAV-ytor.",
    navInputsRequiresLogin: "Logga in för att se navigationsutrustning från nav inputs på detta lager.",
    loginToSeeInputs: "Logga in för att se underlag på detta lager.",
    runAnalysisFirst: "Kör en analys först för att visa ytor.",
    waypoints: "Waypoints",
    shieldingVorDmeLabel: "VOR/DME (utvärderas som VOR + DME OMNI)",
    shieldingNavAidType: "Typ av navigationsutrustning",
    shieldingNavAidName: "Namn på navigationsutrustning",
    shieldingIdent: "Identitet",
    shieldingFrequency: "Frekvens",
    shieldingChannel: "Kanal",
    shieldingElevation: "Höjd",
    shieldingNavAidPosition: "Position",
    shieldingEarthCurvature: "Jordkrökning",
    shieldingTrueTrack: "Sann bana (°)",
    shieldingDistToThr: "Avstånd till tröskel (m)",
    shieldingRemarks: "Anmärkning",
    shieldingObstaclesChecked: "Kontrollerade hinder",
    shieldingObstacleEvals: "Hinderbedömningar",
    shieldingWithinSurface: "Inom skyddsyta",
    shieldingColObstacleName: "Hindernamn",
    shieldingColAltM: "Höjd (m)",
    shieldingColAltFt: "Höjd (ft)",
    shieldingColSurface: "Yta",
    shieldingColSurfAltM: "Ytans höjd (m)",
    shieldingColSurfAltFt: "Ytans höjd (ft)",
    shieldingColCurvCorr: "Jordkrökn. korr. (m)",
    shieldingColDiffM: "Skillnad (m)",
    shieldingColDiffFt: "Skillnad (ft)",
    shieldingColCritical: "Kritisk",
    shieldingNoObstacles: "Inga hinder inom skyddsytan.",
    shieldingNoObstaclesAny: "Inga hinder inom skyddsytan för något navigationshjälpmedel.",
    shieldingNoNavAids: "Inga navigationshjälpmedel hittades inom 50 km.",
    shieldingZoneGround: "Mark",
    shieldingZoneLateral: "Lateral",
    shieldingZoneSloping: "Sluttande",
    shieldingZoneInner: "Inre",
    shieldingZoneCone: "Kon",
    shieldingZoneExtended: "Utökad",
    // OAS
    oasResults: "OAS-beräkningsresultat",
    oasError: "OAS-beräkningsfel",
    oasCategory: "OAS-kategori",
    oasAircraftCategory: "Flygplanskategori",
    oasObstacleName: "Hindrets namn",
    oasObstacleAltM: "Hinderhöjd (m)",
    oasIlsX: "ILS X (m)",
    oasIlsY: "ILS Y (m)",
    oasEqAlt: "Ekvivalent höjd (m)",
    oasSurface: "Yta",
    oasSurfaceAltM: "Ytans elev. (m)",
    oasSurfaceAltFt: "Ytans elev. (ft)",
    oasDiffM: "Diff. (m)",
    oasDiffFt: "Diff. (ft)",
    oasOcaM: "OCA (m)",
    oasOcaFt: "OCA (ft)",
    oasControlling: "Styrande",
    oasCritical: "Kritisk",
    oasConstants: "OAS-konstanter",
    oasInputParams: "Indataparametrar",
    oasMacg: "MA stiggradient (%)",
    oasGroundPlane: "Markplan",
    // BARO/VNAV OAS
    baroVnavResults: "BARO/VNAV OAS Beräkningsresultat",
    baroVnavError: "BARO/VNAV OAS Beräkningsfel",
    baroVnavAircraftCategory: "Flygplanskategori",
    baroVnavIas: "Max IAS (kts)",
    baroVnavIasAtThr: "Max IAS vid LTP/FTP (kts)",
    baroVnavHeightLoss: "Höjdförlust HL (m)",
    baroVnavTempCorr: "Temperaturkorrigering TC (m)",
    baroVnavXfap: "X FAP (m)",
    baroVnavXfas: "X FAS",
    baroVnavFasAngle: "FAS Vinkel",
    baroVnavXz: "Xz",
    baroVnavMinVpa: "Min VPA (°)",
    baroVnavMaxTemp35: "Max temp vid 3,5° VPA (°C)",
    baroVnavOffsetAngle: "Offsetvinkel (°)",
    baroVnavDMin: "Min D (m)",
    baroVnavOchMin: "Min OCH (m)",
    baroVnavOchMinFt: "Min OCH (ft)",
    baroVnavOcaMin: "Min OCA (m)",
    baroVnavOcaMinFt: "Min OCA (ft)",
    baroVnavInputParams: "Indataparametrar",
    baroVnavVpa: "VPA (°)",
    baroVnavRdh: "RDH",
    baroVnavMinAlt: "Min altitude (ft)",
    baroVnavMinTemp: "Min temperatur (°C)",
    baroVnavIsaDev: "ISA-avvikelse (°C)",
    baroVnavMacg: "MA stiggradient (%)",
    baroVnavEvalMethod: "Utvärderingsmetod MA",
    baroVnavOch: "OCH (m)",
    // BARO/VNAV obstacle table columns
    baroVnavObstName: "Hindernamn",
    baroVnavObstAlt: "Hinder alt. (m)",
    baroVnavArea: "Område",
    baroVnavDistInSec: "Avst. fr. innerkant (m)",
    baroVnavAlongTrackM: "Längs-bana avst. (m)",
    baroVnavMocM: "MOC (m)",
    baroVnavMocFt: "MOC (ft)",
    baroVnavEqHeightM: "Ekv. höjd (m)",
    baroVnavEqHeightFt: "Ekv. höjd (ft)",
    baroVnavEqAltM: "Ekv. alt. (m)",
    baroVnavEqAltFt: "Ekv. alt. (ft)",
    baroVnavSurface: "Yta",
    baroVnavSurfAltM: "Ytans alt. (m)",
    baroVnavSurfAltFt: "Ytans alt. (ft)",
    baroVnavDiffM: "Diff. (m)",
    baroVnavDiffFt: "Diff. (ft)",
    baroVnavHlM: "HL (m)",
    baroVnavHlFt: "HL (ft)",
    baroVnavHlCorrection: "Höjdförlustkorrigering (m)",
    baroVnavOcaM: "OCA (m)",
    baroVnavOcaFt: "OCA (ft)",
    baroVnavCritical: "Kritisk",
    baroVnavNoObstacles: "Inga hinder inom skyddsyta",
    baroVnavArpElevFt: "ARP-höjd",
    baroVnavInboundTrack: "Inbound Track (°)",
    baroVnavPublishedMinima: "Publicerade minima",
    baroVnavNoPublishedMinima: "inga publicerade minima",
    oasPublishedMinima: "Publicerade minima",
    // Layer panel Show toggles
    layerShowOmni: "Visa OMNI-ytor",
    layerShowOasIls1: "Visa OAS ILS CAT I",
    layerShowOasIls2: "Visa OAS ILS CAT II",
    layerShowOasIls2ap: "Visa OAS ILS CAT II AP",
    layerShowOasSbasApv1: "Visa OAS SBAS APV I",
    layerShowOasSbasCat1: "Visa OAS SBAS CAT I",
    layerShowBaro: "Visa BARO/VNAV-ytor",
    layerShowVss: "Visa VSS-ytor",
    layerShowBaseTurn: "Visa Base Turn-ytor",
    layerShowConvHolding: "Visa Conv. Holding (Tid)",
    layerShowConvRacetrack: "Visa Conv. Racetrack (Tid)",
    layerShowConvHoldingDist: "Visa Conv. Holding/Racetrack (Avstånd)",
    layerShowRnavHolding: "Visa RNAV Holding-ytor",
    layerShowRnpHolding: "Visa RNP Holding-ytor",
    layerShowVorDmeHolding: "Visa VOR/DME Holding-ytor",
    layerShowMsa: "Visa MSA-sektorer",
    layerShowTaa: "Visa TAA",
    layerShowCircling: "Visa Visual Circling",
    layerShowGnssApch: "Visa GNSS Apch",
    // Base Turn
    baseTurnResults: "Base Turn Beräkningsresultat",
    // VSS
    vssResults: "VSS Beräkningsresultat",
    vssError: "VSS Beräkningsfel",
    vssInputParams: "Indataparametrar",
    vssObstAltM: "Alt (m)",
    vssObstAltFt: "Alt (ft)",
    vssDisregardable: "Ej signifikant",
    vssImpact: "Påverkan",
    // PDF-only abbreviated column headers – OMNI table (Swedish)
    pdfOmniArea: "Area",
    pdfOmniElevM: "Elev. (m)",
    pdfOmniDrDist: "Dr",
    pdfOmniDoDist: "Do (m)",
    pdfOmniReqMoc: "MOC (ft)",
    pdfOmniActAlt: "Flyghöjd (ft)",
    pdfOmniReqAlt: "Korsningshöjd (ft)",
    pdfOmniPdg: "PDG (%)",
    pdfOmniCritical: "Kritiskt",
    pdfOmniCio: "CIO",
    pdfOmniObstacleTable: "Hindertabell",
    pdfBaroAircraftCategory: "Fpl. kat.",
    pdfBaroIasAtThr: "MAX IAS LTP (kts)",
    pdfBaroHeightLoss: "HL (m)",
    pdfBaroHlCorrection: "HL korr. (m)",
    pdfBaroTempCorr: "Temp korr. (m)",
    pdfBaroFasAngle: "FAS (°)",
    pdfBaroMaxTemp35: "Max (°C)",
  },
  en: {
    // Header & navigation
    importGeoJSON: "Import GeoJSON",
    exportGeoJSON: "Export GeoJSON",
    selectAirport: "Select airport",
    information: "Information",
    help: "Help",
    aboutUs: "About Us",
    language: "English",
    close: "Close",
    // Tooltip
    tooltip_measure: "Click the map to measure distance",
    tooltip_openCoordInput: "Open coordinate input",
    tooltip_draw: "Draw objects on the map",
    tooltip_delete: "Delete object",
    tooltip_zoom: "Zoom in/out on the map",
    tooltip_help: "Show help information",
    tooltip_info: "Show more information",
    // Leaflet draw tooltips
    tooltip_edit: "Edit layers",
    tooltip_editDisabled: "No layers to edit",
    tooltip_deleteDisabled: "No layers to delete",
    tooltip_drawPolylineStart: "Click to start drawing line",
    tooltip_drawPolylineCont: "Click to continue drawing line",
    tooltip_drawPolylineEnd: "Click last point to finish line",
    tooltip_drawPolygonStart: "Click to start drawing shape",
    tooltip_drawPolygonCont: "Click to continue drawing shape",
    tooltip_drawPolygonEnd: "Click first point to close this shape",
    tooltip_drawMarker: "Click map to place marker",
    tooltip_drawCircleStart: "Click and drag to draw circle",
    tooltip_drawCircleRadius: "Radius",
    tooltip_zoomIn: "Zoom in",
    tooltip_zoomOut: "Zoom out",
    // LayerPanel
    backgroundLayers: "Background layers",
    userdataLayers: "User´s data layers",
    informationLayers: "Information layers",
    protectionAreas: "Airport protection areas",
    openStreetMap: "OpenStreetMap",
    cartoDBLight: "CartoDB Light",
    esriAerial: "ESRI Aerial imagery",
    openRailwayMap: "OpenRailwayMap",
    swedishAirports: "Swedish airports",
    enrNavaids: "ENR NAVAIDS",
    nav: "NAV",
    tmaTia: "TMA/TIA",
    ctrTizRmz: "CTR/TIZ/RMZ",
    icaoDoc015: "ICAO Doc 015",
    easa: "EASA MVA",
    pansOps: "ICAO Doc 8168-PANS OPS",
    reloadLayers: "Reload layers",
    loadingLayers: "Loading layers...",
    analyzingData: "Analyzing data...",
    generatingPdfReport: "Generating PDF report...",
    toggleLayer: "Toggle layer",
    turnOnLayer: "Show",
    turnOffLayer: "Hide",
    zoomToAirport: "Zoom to airport",
    noAirportSelected: "No airport selected",
    loadingAirports: "Loading airports...",
    error: "Error",
    // CoordinateInputTool
    coordinateInput_title: "Coordinate input",
    coordinateInput_point: "Point",
    coordinateInput_line: "Line",
    coordinateInput_polygon: "Polygon",
    coordinateInput_circle: "Circle",
    coordinateInput_coordFormat: "Coordinate format:",
    coordinateInput_name: "Name:",
    coordinateInput_clear: "Clear form",
    coordinateInput_zoom: "Zoom to new object",
    coordinateInput_addToMap: "Add to map",
    coordinateInput_radius: "Radius:",
    coordinateInput_unit_nm: "NM",
    coordinateInput_unit_meter: "meter",
    coordinateInput_error: "You must enter lat, lon, z on each row. All values must be correct.",
    coordinateInput_placeholder_point: "Enter: lat, lon, z\nEx: 58.233333, 17.116667, 120",
    coordinateInput_placeholder_line: "Enter each point on a new line:\n58.233333, 17.116667, 120\n58.233333, 17.516667, 130",
    coordinateInput_placeholder_polygon: "Enter each vertex on a new line (first and last points are joined):\n58.233333, 17.116667, 120\n58.233333, 17.516667, 120\n57.833333, 17.233333, 120\n58.233333, 17.116667, 120",
    coordinateInput_placeholder_circle: "Enter center on one line: lat, lon, z\nEx: 58.233333, 17.116667, 120\nSpecify radius below.",
    // Coordinate format help
    coordinateInput_formatHelp: "Coordinate format help:",
    coordinateInput_formatHelp_dd: "DD.dddddd (Decimal degrees): 58.233333, 17.116667",
    coordinateInput_formatHelp_dm: "DDMM.MMMM (Degrees, decimal minutes): 5814.0000, 1707.0000",
    coordinateInput_formatHelp_dms: "DMS: 594559.23N, 162425.42E or 59°45'59.23\"N, 16°24'25.42\"E. Append the elevation, e.g. , 100.",
    coordinateInput_rowHint: "One point per line: latitude, longitude, elevation z (m AMSL).",
    // Mode toggle
    coordinateInput_modeManual: "Manual",
    coordinateInput_modeImport: "Import",
    coordinateInput_uploadFile: "Upload file…",
    coordinateInput_importTitle: "Import objects",
    // BulkImportTool
    bulkImport_delimiter: "Delimiter:",
    bulkImport_delim_semicolon: "Semicolon (;)",
    bulkImport_delim_comma: "Comma (,)",
    bulkImport_delim_space: "Space",
    bulkImport_delim_tab: "Tab",
    bulkImport_delim_custom: "Custom",
    bulkImport_customDelimPlaceholder: "e.g. |",
    bulkImport_coordFormat: "Coordinate format:",
    bulkImport_hasHeader: "First row is a header",
    bulkImport_pasteData: "Paste data:",
    bulkImport_uploadFile: "Choose file",
    bulkImport_dropzoneHint: "Click to choose a file (.csv, .txt, .tsv) – or paste data below",
    bulkImport_chooseFile: "Choose file…",
    bulkImport_orPaste: "Or paste data directly:",
    bulkImport_pastePlaceholder: "Paste CSV/TSV data here…\nEx: 58.233333,17.116667,120,TowerA",
    bulkImport_columnMapping: "Column mapping",
    bulkImport_col_lat: "Latitude",
    bulkImport_col_lon: "Longitude",
    bulkImport_col_alt: "Altitude (z)",
    bulkImport_col_name: "Name",
    bulkImport_col_radius: "Radius",
    bulkImport_role_ignore: "Ignore",
    bulkImport_colNone: "— none —",
    bulkImport_radiusUnit: "Radius unit:",
    bulkImport_preview: "Preview –",
    bulkImport_validOf: "{valid} valid of {total}",
    bulkImport_valid: "OK",
    bulkImport_import: "Import {count} objects",
    bulkImport_showingFirst100: "Showing first 100 rows.",
    bulkImport_noValidRows: "No valid rows to import.",
    bulkImport_nameRequired: "⚠ Select a column for Name – required for import.",
    // HelpPopup
    help_title: "Tool help",
    help_measure: "Click to measure distances and areas on the map. Double-click to finish measuring.",
    help_zoom: "Use the mouse wheel or +/- buttons to zoom in and out on the map.",
    help_layers: "Switch between different background layers and show/hide information layers.",
    // InformationPopup
    info_tips_title: "User tips",
    info_tips_1: "This application helps you analyze obstacle limitation surfaces (OLS) for airports.",
    info_tips_2: "Use the layer panel to show different background layers and information layers.",
    info_tips_3: "Select an airport from the dropdown menu to zoom to its location.",
    info_tips_4: "Upload GeoJSON files to analyze objects against the airport protection zones.",
    info_tips_5: "Click objects on the map for more information.",
    info_tips_6: "Click the help icon for information about tools and features.",
    // GeoJsonIO
    geoJson_uploadFailed: "Could not parse GeoJSON!",
    // CoordinateInfoBox
    coordinateInfo_format: "Coordinate format:",
    coordinateInfo_lat: "Lat:",
    coordinateInfo_lng: "Lng:",
    coordinateInfo_z: "z (lowest surface AMSL):",
    coordinateInfo_zAccessMessage: "Log in with an active subscription to view the real-time Z-value.",
    // ANALYSIS & PDF/Tables
    exportPdfTitle: "FlightSafe Analyzer Resultat of Flight safe analisis",
    analyze: "Analyze",
    exportPdf: "Export PDF report",
    result: "Result",
    penetration: "Surface penetration",
    noPenetration: "No penetrations",
    object: "Object",
    airport: "Airport",
    surface: "Surface",
    runway: "Runway",
    regulation: "Regulation",
    objectHeightM: "Z (m) AMSL",
    surfaceHeightM: "Surface (m) AMSL",
	//objectHeightM: "Object height (m)",
    //surfaceHeightM: "Surface height (m)",
    penetratesQ: "Impact?",
    yes: "Yes",
    no: "No",
    numPoints: "Num points",
    penetrationMAll: "Penetration",
    horizontalTolerance: "Horizontal tolerance (m)",
    greenHint: "Green row = no penetration",
    redHint: "Red row = penetration",
    tips: "Tips",
    toggleLayersTip: "Use the panel on the right to show/hide layers.",
    switchBasemapTip: "Switch basemap with the layer panel.",
    drawDeleteTip: "Draw or delete objects using the drawing tool.",
    coordHeightPanelTip: "Hover over objects to see coordinates and altitude.",
    circleZRadiusTip: "Circles are drawn with center, altitude and radius.",
    importExportTip: "Import or export GeoJSON files to save/load objects.",
    tipAlwaysChooseSaveLocation: "Always choose where the file is saved.",
    browserDownloadHint: " (the browser may ask for location when downloading).",
    importReplacePrompt: "Do you want to replace existing objects or add?",
    replace: "Replace",
    add: "Add",
    cancel: "Cancel",
    loading: "Loading...",
    geometry: "Geometry",
    // PropertyModal
    objectProperties: "Object properties",
    pointProperties: "Point properties",
    lineProperties: "Line properties",
    circleProperties: "Circle properties", 
    name: "Name",
    height: "Z (m) AMSL",
    lineHeightDescription: "Z-value for each point (comma-separated) or a single value for the entire line",
    lineHeightPlaceholder: "Ex: 15,16,17 or 15",
    radius: "Radius (meters)",
    save: "Save",
    // PDF Export
    pdfTitle: "FlightSafe Analyzer – Obstacle Analysis",
    background: "Background",
    backgroundText1: "{contact_person} ({email}){company} has performed an aviation obstacle analysis using FlightSafe Analyzer on {date}.",
    backgroundText1Fallback: "You have performed an aviation obstacle analysis using FlightSafe Analyzer on {date}.",
    backgroundText2: "The analysis covers impact on air traffic and technical equipment in the area.",
    affectedAirports: "Affected airports",
    noAffectedAirports: "(No affected airports/hospitals identified)",
    resultSummary: "Summary of results",
    resultSummaryText: "Below is an overview of the analysis results, where each object and its impact on various aviation safety areas are reported.",
    analysisTitle: "Analysis",
    analysisIntro: "The obstacle analysis consists of five parts:",
    analysisPart1: "1. List of planned building(s)",
    analysisPart2: "2. Impact on airports' obstacle limitation surfaces",
    analysisPart3: "3. Impact on airports' airspace",
    analysisPart4: "4. Impact on airports' flight procedures",
    analysisPart5: "5. Impact on airports' technical equipment",
    buildingsList: "1. List of planned building(s)",
    objectType: "Object type",
    coordinates: "Coordinates (DMS)",
    mapTitle: "Map of planned building(s)",
    impactOnSurfaces: "2. Impact on airports' obstacle limitation surfaces",
    penetratesEasa: "Penetrates surface (EASA MVA)",
    noPenetrationEasa: "No penetrations but within surface (EASA MVA)",
    impactOnAirspace: "3. Impact on airports' airspace",
    airspaceType: "Type",
    lowerLimit: "Lower",
    upperLimit: "Upper",
    airportCode: "Airport code",
    objectName: "Object name",
    airspace: "Airspace",
    airspaceWarning: "{count} drawn objects fall within the following airspace: {airspaces}.",
    airspaceWarningText: "Wind farms and objects with a height above 100 meters above ground level (AGL) should be avoided within these airspaces, as they may pose a significant risk to aviation safety.",
    noAirspaceText: "No drawn objects fall within identified airspace (CTR/TIZ/RMZ) in the database.",
    impactOnProcedures: "4. Impact on airports' flight procedures",
    penetratesPansOps: "Penetrates surface (ICAO Doc 8168-PANS OPS)",
    noPenetrationPansOps: "No penetrations but within surface (ICAO Doc 8168-PANS OPS)",
    impactOnTechnicalEquipment: "5. Impact on airports' technical equipment",
    impactOnSurfacesAnnex14: "Impact on airports' obstacle limitation surfaces (ICAO ANNEX 14)",
    impactOnSurfacesEasa: "Impact on ATS vector altitude",
    impactOnSurfacesEtod: "Impact on airports' Area 1-4 (eTOD)",
    penetratesAnnex14: "Penetrates surface (ICAO ANNEX 14)",
    noPenetrationAnnex14: "No penetrations but within surface (ICAO ANNEX 14)",
    penetratesEtod: "Penetrates surface (ICAO ANNEX 15-eTOD)",
    noPenetrationEtod: "No penetrations but within surface (ICAO ANNEX 15-eTOD)",
    noImpact: "No impact identified.",
    shieldingPenetrationNote: "The object penetrates airport technical equipment surfaces in accordance with ICAO EUR Doc 015. Although the surface is not height-limiting, the guidance indicates that obstacles that do penetrate the surfaces require more detailed analysis to determine the nature of any interference with CNS signals.",
    importantInformation: "Important information",
    importantInfoText: "According to aviation law, an obstacle notification must be sent to the Armed Forces at least four weeks before the object reaches 20 m height or 45 m within built-up areas.\nObstacles must be marked according to Transport Agency regulations (TSFS 2020:88 and TSFS 2019:22).",
    recommendation: "Recommendation",
    recommendationText: "Contact affected airports directly for their assessment, as they are stakeholders in the matter.",
    airportAddresses: "Address information for affected airports",
    operator: "Operator",
    address: "Address",
    phone: "Phone",
    fax: "Fax",
    email: "Email",
    website: "Website",
    noAddressRegistered: "(No address registered)",
    pageOf: "Page {current} of {total}",
    footerText: "FlightSafe Analyzer • www.flightsafe.se",
    date: "Date",
    // Table headers
    object: "Object",
    analysis: "Analysis",
    withinSurfaceYes: "With. surf. Yes",
    withinSurfaceNo: "With. surf. No", 
    comment: "Comment",
    withoutNotification: "w/out notif.",
    withNotification: "Notif.",
    summaryCritical: "Critical",
    // ResultatTable
    analysisError: "Error fetching analysis",
    invalidAnalysisResult: "Invalid analysis result from server",
    couldNotFetchAnalysis: "Could not fetch analysis",
    noAnalysisToShow: "No analysis to show yet.",
    loadingAnalysis: "Loading analysis...",
    // Analysis types for buildSummaryRows
    analysisType_surfacesAnnex14: "Obstacle limitation surfaces (ICAO ANNEX 14)",
    analysisType_surfacesEasa: "ATS vector altitude",
    analysisType_surfacesEtod: "Area 1-4 (eTOD)",
    analysisType_airspaceTmaTia: "Airspace (TMA/TIA)",
    analysisType_airspaceAts: "Airspace (CTR/TIZ/RMZ/ATS)",
    analysisType_proceduresPansOps: "Flight procedures (ICAO Doc 8168-PANS OPS)",
    analysisType_technicalIcao: "Technical equipment (ICAO Doc 015)",
    // Comments for buildSummaryRows
    commentNoImpact: "No impact.",
    commentPenetrates: "Object penetrates the surface.",
    commentWithinNoImpact: "Object within surface, no impact.",
    commentOutsideTmaTia: "Object outside TMA/TIA airspace.",
    commentOutsideAts: "Object outside controlled ATS airspace.",
    commentWithinAirspace: "Object within {type} airspace.",
    commentWithinTmaTia: "Object within TMA/TIA airspace.",
    commentWithinAts: "Object within ATS airspace.",
    unit: "Unit",
    // Language toggle
    tooltip_languageToggle: "Switch to Swedish",
    // Authentication
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email address",
    password: "Password",
    confirmPassword: "Confirm password",
    loginTitle: "Login",
    registerTitle: "Register user",
    loginButton: "Login",
    registerButton: "Register",
    forgotPassword: "Forgot password?",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    clickHereToLogin: "Click here to login",
    clickHereToRegister: "Click here to register",
    airportAccess: "Airport access",
    airportAccessHelp: "Choose which airports you want access to",
    accessLevel_NONE: "No access",
    searchAirportPlaceholder: "Search airport...",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    noAirportsSelected: "No airports selected",
    oneAirportSelected: "1 airport selected",
    manyAirportsSelected: "{{count}} airports selected",
    done: "✔ Done!",
    chooseMinAirports: "Select at least 1 airport!",
    regionStockholm: "Stockholm",
    regionSouthSweden: "Southern Sweden",
    regionWestSweden: "Western Sweden",
    regionNorthSweden: "Northern Sweden",
    regionEastSweden: "Eastern Sweden",
    regionCentralSweden: "Central Sweden",
    accessLevel_ESSA: "ESSA only (Stockholm Arlanda)",
    accessLevel_ESSP: "ESSP only (Norrköping Kungsängen)",
    accessLevel_MULTI: "ESSA, ESSB, ESSP",
    accessLevel_ALL: "All airports",
    registrationSuccess: "Registration successful! You can now log in.",
    loginSuccess: "Login successful!",
    loginFailed: "Invalid login credentials",
    registrationFailed: "Registration failed",
    passwordMismatch: "Passwords do not match",
    requiredField: "This field is required",
    // Version info
    version: "Version:",
    lastUpdated: "Last updated:",
    // Subscription/Payment messages
    subscriptionRequired: "Subscription required",
    subscriptionMessage: "To export PDF reports, you need an active subscription. Contact us for more information. Please note that the subscription is completely free of charge and comes with no obligations!",
    footerSubscriptionInfo: "To export PDF reports, you need an active subscription. Please note that the subscription is completely free of charge and comes with no obligations!",
    contactForSubscription: "Contact us for subscription",
    currentUser: "Logged in as:",
    accessLevel: "Access level:",
    paymentStatus: "Payment status:",
    paid: "Active",
    notPaid: "Not active",
    // Subscription modal translations
    haveAccountHeading: "Already have an account?",
    haveAccountDesc: "Log in to check your subscription status",
    newAccountHeading: "New account?",
    newAccountDesc: "Register to get started",
    contactUsHeading: "Want to contact us?",
    contactUsDesc: "Contact us for information about subscription",
    continueWithoutRegistration: "Continue without subscription",
    continueDisclaimer: "Limited functionality without a subscription",
    loginRequiredTitle: "Login required",
    loginRequiredMessage: "You must be logged in to order an obstacle analysis. Please log in or register an account to continue.",
    loginRequiredLoginButton: "Log in",
    loginRequiredRegisterButton: "Register",
    // Free PDF exports limit messages
    freeExportsExhausted: "Analyses without active subscription used",
    freeExportsExhaustedMessage: "You have used your 3 analyses without an active subscription. To continue exporting analyses, you need an active subscription.",
    freeExportsContactMessage: "Please note that the subscription is completely free of charge and comes with no obligations! Contact us to activate your subscription or if you have any questions.",
    contactInformation: "Contact information",
    freeExportsRemaining: "You have {{count}} free PDF export(s) remaining",
	// Tips under resultat
	tip: "Tip",
	// --- NEW CLARIFICATION TEXTS ---
    etodClarification: "The object penetrates the eTOD surface in accordance with ICAO Annex 15. Although the surface is not height-limiting, any obstacle that penetrates it must be published in the AIP by the affected airport(s). Permanent obstacles should preferably be avoided, as they may limit the future planning of arrival and departure procedures at the airport(s).",
    techEquipmentClarification: "The object penetrates the surface for technical equipment. While the surface is not height-limiting, the intrusion may still require a specific assessment to ensure that navigation and surveillance systems are not adversely affected. Large permanent structures, such as buildings or wind turbines, should be avoided within these areas.",
    // OCA dynamic text translations
    ocaBothSurfaces: "The object penetrates LPV OAS and ILS OAS, but does not affect OCA (minima).",
    ocaLpvOnly: "The object penetrates LPV OAS, but does not affect OCA (minima).",
    ocaIlsOnly: "The object penetrates ILS OAS, but does not affect OCA (minima).",
    pdfReportTip: "Create a PDF report with complete calculations",
    // About Us modal content
    aboutUs_title: "About Us",
    aboutUs_intro: "We make it easy to take responsibility for flight safety – in just seconds.",
    aboutUs_description: "At Flightsafe, we've developed a web-based self-service tool that allows you to quickly and easily check whether a planned structure — such as a mast, crane, building, or any other object — could affect airports or controlled airspace.\n\nOur platform is designed to support both individuals and organizations in making informed decisions without delay. With direct access to up-to-date airport and airspace data, you'll receive reliable results instantly — eliminating uncertainty and unnecessary waiting.",
    aboutUs_whatWeDo_title: "What We Do",
    aboutUs_whatWeDo_content: "We offer a digital platform that automates and simplifies obstacle assessments. The service is used by:\n• Builders, contractors, and private individuals who want to ensure their planned objects do not interfere with air traffic.\n• Airports that need to monitor potential obstacles near their operational zones and assess their impact on safety or operations.\n• Local ANS (Air Navigation Service) providers who need to safeguard their airspace and ensure navigation and traffic services remain unaffected by new obstacles.\n\nWith Flightsafe, you can:\n• Check whether an object may interfere with protected airspace or zones around airports.\n• Get an instant response on-screen, based on validated and current aeronautical data.\n• Download documentation confirming the obstacle check has been performed.\n• Receive guidance on potential next steps – such as permit applications or contacting the relevant authorities.",
    aboutUs_mission_title: "Our Mission",
    aboutUs_mission_content: "We aim to make obstacle assessments and airspace safety checks accessible, understandable, and fast – whether you're building a house, managing an airport, or operating an ANS unit.\nBy digitizing and simplifying the process, we reduce the risk of errors, delays, and unintended impacts on aviation safety – while strengthening cooperation between land-based projects and airspace stakeholders.",
    aboutUs_forWhom_title: "Who It's For",
    aboutUs_forWhom_content: "• Construction companies & contractors installing cranes, masts, or other tall structures.\n• Private individuals planning buildings or tall objects near airports.\n• Consultants & project managers ensuring compliance with aviation regulations.\n• Airports that want to monitor potential obstacles in their vicinity.\n• Local ANS providers working to protect their controlled airspace from external impact.",
    aboutUs_whyChooseUs_title: "Why Choose Flightsafe?",
    aboutUs_whyChooseUs_content: "✅ Instant Results: No processing time – get your answer right away.\n✅ Reliable Data: All information is kept up to date in accordance with the global AIRAC cycle and relevant regulations.\n✅ User-Friendly: Just enter your object's details – we'll do the rest.\n✅ Clear Documentation: Receive downloadable reports for decisions, permits, or internal records.\n✅ Scalable: Whether you're running a single project or managing a complex aviation operation, the service adapts to your needs.",
    aboutUs_future_title: "Looking Ahead",
    aboutUs_future_content: "Aviation safety evolves – and we make sure you always have the most current data at your fingertips.\nOur system is continuously maintained and updated in line with the AIRAC cycle, ensuring every assessment is based on the latest available information.\nWith Flightsafe, you're always one step ahead – whether you're building on the ground or managing the airspace above.",
    aboutUs_contact_title: "Contact Us",
    aboutUs_contact_content: "Have questions or need guidance with your obstacle check? We're here to help.\n\n📩 Feel free to reach out:\nkundtjanst@flightsafe.se – for general inquiries\nsupport@flightsafe.se – for technical assistance or case-specific support\n\nWe usually respond the same day.\nDon't hesitate to get in touch – sometimes one email is all it takes to get full clarity.",
    // OMNI Departure Analysis
    analyzeOmni: "OMNI Analysis",
    omniResults: "OMNI Departure Results",
    omniDepartureResults: "OMNI departure results",
    omniDepartures: "OMNI Departures",
    airport: "Airport",
    runway: "Runway",
    omniObjectWithin: "Object within",
    omniImpact: "impact",
    omniNoImpact: "no impact",
    omniNoImpactCio: "no impact",
    omniCio: "CIO",
    totalObstaclesAssessed: "Total Obstacles Assessed",
    criticalObstacle: "Critical Obstacle",
    calculationDetails: "Calculation Details",
    drDistance: "Dr distance",
    doDistance: "Do distance",
    requiredMocFt: "Required MOC (ft)",
    actualAircraftAltitudeFt: "Actual Aircraft Altitude (ft)",
    requiredCrossingAltitudeFt: "Required Crossing Altitude (ft)",
    requiredPdg: "Required PDG (%)",
    criticalObstacleCol: "Critical Obstacle",
    closeInObstacleCol: "Close-in Obstacle",
    // OMNI PDF export translations
    impactOnFlightProcedures: "Impact on airports' flight procedures",
    omniTableAirport: "Airport",
    omniTableRunway: "Runway",
    omniTableArea: "Area",
    omniTableStatus: "Status",
    omniTablePdg: "PDG Impact",
    cioNote: "Close-in obstacles (CIOs) exist; however, they can be disregarded for calculation purposes.",
    omniError: "OMNI Analysis Error",
    omniInputParams: "Input Parameters",
    // Shielding / Nav Aid obstacle analysis
    shieldingNavAidTitle: "Nav Aid Calculation Results",
    shieldingToggleHide: "Hide NAV surfaces",
    shieldingToggleShow: "Show NAV surfaces",
    navSurfacesRequiresAnalysis: "Run an analysis first to show NAV surfaces.",
    navInputsRequiresLogin: "Log in to see nav inputs on this layer.",
    loginToSeeInputs: "Log in to see inputs on this layer.",
    runAnalysisFirst: "Run an analysis first to show surfaces.",
    waypoints: "Waypoints",
    shieldingVorDmeLabel: "VOR/DME (evaluated as VOR + DME OMNI)",
    shieldingNavAidType: "Nav Aid Type",
    shieldingNavAidName: "Nav Aid Name",
    shieldingIdent: "Ident",
    shieldingFrequency: "Frequency",
    shieldingChannel: "Channel",
    shieldingElevation: "Elevation",
    shieldingNavAidPosition: "Nav Aid Position",
    shieldingEarthCurvature: "Earth Curvature",
    shieldingTrueTrack: "True Track (°)",
    shieldingDistToThr: "Dist to THR (m)",
    shieldingRemarks: "Remarks",
    shieldingObstaclesChecked: "Obstacles checked",
    shieldingObstacleEvals: "Obstacle evaluations",
    shieldingWithinSurface: "Within protected surface",
    shieldingColObstacleName: "Obstacle Name",
    shieldingColAltM: "Alt (m)",
    shieldingColAltFt: "Alt (ft)",
    shieldingColSurface: "Surface",
    shieldingColSurfAltM: "Surf. Alt (m)",
    shieldingColSurfAltFt: "Surf. Alt (ft)",
    shieldingColCurvCorr: "Curvature Corr. (m)",
    shieldingColDiffM: "Diff (m)",
    shieldingColDiffFt: "Diff (ft)",
    shieldingColCritical: "Critical",
    shieldingNoObstacles: "No obstacles within protected surface.",
    shieldingNoObstaclesAny: "No obstacles within protected surface for any navigation aid.",
    shieldingNoNavAids: "No navigation aids found within 50 km.",
    shieldingZoneGround: "Ground",
    shieldingZoneLateral: "Lateral",
    shieldingZoneSloping: "Sloping",
    shieldingZoneInner: "Inner",
    shieldingZoneCone: "Cone",
    shieldingZoneExtended: "Extended",
    // OAS
    oasResults: "OAS Calculation Results",
    oasError: "OAS Calculation Error",
    oasCategory: "OAS Category",
    oasAircraftCategory: "Aircraft Category",
    oasObstacleName: "Obstacle Name",
    oasObstacleAltM: "Obstacle Alt (m)",
    oasIlsX: "ILS X (m)",
    oasIlsY: "ILS Y (m)",
    oasEqAlt: "Equiv. Alt (m)",
    oasSurface: "Surface",
    oasSurfaceAltM: "Surface Alt (m)",
    oasSurfaceAltFt: "Surface Alt (ft)",
    oasDiffM: "Diff (m)",
    oasDiffFt: "Diff (ft)",
    oasOcaM: "OCA (m)",
    oasOcaFt: "OCA (ft)",
    oasControlling: "Controlling",
    oasCritical: "Critical",
    oasConstants: "OAS Constants",
    oasInputParams: "Input Parameters",
    oasMacg: "MA climb gradient",
    oasGroundPlane: "Ground Plane",
    // BARO/VNAV OAS
    baroVnavResults: "BARO/VNAV OAS Calculation Results",
    baroVnavError: "BARO/VNAV OAS Calculation Error",
    baroVnavAircraftCategory: "Aircraft Category",
    baroVnavIas: "Max IAS (kts)",
    baroVnavIasAtThr: "Max IAS at LTP/FTP (kts)",
    baroVnavHeightLoss: "Height Loss HL (m)",
    baroVnavTempCorr: "Temperature Correction TC (m)",
    baroVnavXfap: "X FAP (m)",
    baroVnavXfas: "X FAS",
    baroVnavFasAngle: "FAS Angle",
    baroVnavXz: "Xz",
    baroVnavMinVpa: "Min VPA (°)",
    baroVnavMaxTemp35: "Max Temp at 3.5° VPA (°C)",
    baroVnavOffsetAngle: "Offset Angle (°)",
    baroVnavDMin: "Min D (m)",
    baroVnavOchMin: "Min OCH (m)",
    baroVnavOchMinFt: "Min OCH (ft)",
    baroVnavOcaMin: "Min OCA (m)",
    baroVnavOcaMinFt: "Min OCA (ft)",
    baroVnavInputParams: "Input Parameters",
    baroVnavVpa: "VPA (°)",
    baroVnavRdh: "RDH",
    baroVnavMinAlt: "Min Altitude (ft)",
    baroVnavMinTemp: "Min Temperature (°C)",
    baroVnavIsaDev: "ISA Deviation (°C)",
    baroVnavMacg: "MA climb gradient",
    baroVnavEvalMethod: "MA Evaluation Method",
    baroVnavOch: "OCH (m)",
    // BARO/VNAV obstacle table columns
    baroVnavObstName: "Obstacle Name",
    baroVnavObstAlt: "Obstacle Alt (m)",
    baroVnavArea: "Area",
    baroVnavDistInSec: "Dist fr inner edge (m)",
    baroVnavAlongTrackM: "Along-track dist (m)",
    baroVnavMocM: "MOC (m)",
    baroVnavMocFt: "MOC (ft)",
    baroVnavEqHeightM: "Equiv. Height (m)",
    baroVnavEqHeightFt: "Equiv. Height (ft)",
    baroVnavEqAltM: "Equiv. Alt (m)",
    baroVnavEqAltFt: "Equiv. Alt (ft)",
    baroVnavSurface: "Surface",
    baroVnavSurfAltM: "Surface Alt (m)",
    baroVnavSurfAltFt: "Surface Alt (ft)",
    baroVnavDiffM: "Diff (m)",
    baroVnavDiffFt: "Diff (ft)",
    baroVnavHlM: "HL (m)",
    baroVnavHlFt: "HL (ft)",
    baroVnavHlCorrection: "Height Loss Correction (m)",
    baroVnavOcaM: "OCA (m)",
    baroVnavOcaFt: "OCA (ft)",
    baroVnavCritical: "Critical",
    baroVnavNoObstacles: "No obstacles within protection surfaces",
    baroVnavArpElevFt: "ARP Elev",
    baroVnavInboundTrack: "Inbound Track (°)",
    baroVnavPublishedMinima: "Published minima",
    baroVnavNoPublishedMinima: "no published minima",
    oasPublishedMinima: "Published minima",
    // Layer panel Show toggles
    layerShowOmni: "Show OMNI surfaces",
    layerShowOasIls1: "Show OAS ILS CAT I",
    layerShowOasIls2: "Show OAS ILS CAT II",
    layerShowOasIls2ap: "Show OAS ILS CAT II AP",
    layerShowOasSbasApv1: "Show OAS SBAS APV I",
    layerShowOasSbasCat1: "Show OAS SBAS CAT I",
    layerShowBaro: "Show BARO/VNAV surfaces",
    layerShowVss: "Show VSS surfaces",
    layerShowBaseTurn: "Show Base Turn surfaces",
    layerShowConvHolding: "Show Conv. Holding (Time)",
    layerShowConvRacetrack: "Show Conv. Racetrack (Time)",
    layerShowConvHoldingDist: "Show Conv. Holding/Racetrack (Distance)",
    layerShowRnavHolding: "Show RNAV Holding surfaces",
    layerShowRnpHolding: "Show RNP Holding surfaces",
    layerShowVorDmeHolding: "Show VOR/DME Holding surfaces",
    layerShowMsa: "Show MSA sectors",
    layerShowTaa: "Show TAA",
    layerShowCircling: "Show Visual Circling",
    layerShowGnssApch: "Show GNSS Apch",
    // Base Turn
    baseTurnResults: "Base Turn Calculation Results",
    // VSS
    vssResults: "VSS Calculation Results",
    vssError: "VSS Calculation Error",
    vssInputParams: "Input Parameters",
    vssObstAltM: "Alt (m)",
    vssObstAltFt: "Alt (ft)",
    vssDisregardable: "Disregardable",
    vssImpact: "Impact",
    // PDF-only abbreviated column headers – OMNI table (English)
    pdfOmniArea: "Area",
    pdfOmniElevM: "Elev. (m)",
    pdfOmniDrDist: "Dr",
    pdfOmniDoDist: "Do (m)",
    pdfOmniReqMoc: "MOC (ft)",
    pdfOmniActAlt: "Aircraft Alt (ft)",
    pdfOmniReqAlt: "Crossing Alt (ft)",
    pdfOmniPdg: "PDG (%)",
    pdfOmniCritical: "Critical",
    pdfOmniCio: "CIO",
    pdfOmniObstacleTable: "Obstacle Table",
    pdfBaroAircraftCategory: "Cat",
    pdfBaroIasAtThr: "MAX IAS LTP (kts)",
    pdfBaroHeightLoss: "HL (m)",
    pdfBaroHlCorrection: "HL Corr. (m)",
    pdfBaroTempCorr: "TC (m)",
    pdfBaroFasAngle: "FAS (°)",
    pdfBaroMaxTemp35: "Max (°C)",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('sv'); // Default to Swedish

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'sv' ? 'en' : 'sv');
  };

  // Uppdaterad t-funktion som hanterar platsmarkörer
  const t = (key, params) => {
    let text = translations[language][key] || translations['sv'][key] || key;
    if (params) {
      Object.keys(params).forEach(p => {
        text = text.replace(new RegExp(`{{${p}}}`, "g"), params[p]);
      });
    }
    return text;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
};
